<template>
  <BaseCardV2
    :btn-action="loading.repartitionAdherent || hasGraphAffiche ? null : {
      libelle: 'Voir ma trésorerie',
      icon: !isAbonneCulturial ? 'mdi-lock' : '',
      hasOtherAtion: true
    }"
    :erreur="erreur.repartitionAdherent"
    :has-btn-action="false"
    class="pa-2"
    has-help
    titre="Répartition de la trésorerie disponible"
    @otherAction="onClickInformationAbonnement()"
    @on-help="isOpenModalHelp = true"
  >
    <div
      class="mb-2"
    >
      <BaseLoader v-if="loading.repartitionAdherent" />
      <div
        v-else-if="hasCarteRemplie"
        key="tresorerie-active-content"
      >
        <v-row
          class="justify-center"
          no-gutters
        >
          <v-col
            v-if="hasTresoreriePositive"
            cols="12"
            md="5"
          >
            <div
              class="d-flex my-4 libelle-treso"
              :class="estMobile ? 'flex-wrap' : ''"
            >
              <img
                alt="picto-cochon"
                class="picto-cochon align-self-center mr-3"
                src="@/assets/picto-petit-cochon-plus.svg"
              >
              <div class="titre-h4 texte-gris-fonce align-self-center ">
                Trésorerie positive :
              </div>
              <div
                class="titre-h3 --text-branche align-self-center montant-treso"
                :class="estMobile ? 'w-100' : 'ml-2'"
              >
                +{{ tresoreriePositiveTotaleEnEuro | roundNumber(0) | splitNumber }} €
              </div>
            </div>
            <RepartitionBarVertical
              v-model="valueCode"
              :class="estMobile ? '' : 'ml-3'"
              :data="{ items: itemsTresoreriePositive, positive: true }"
              :height="hauteurGraphe(tresoreriePositiveTotaleEnEuro)"
              negative-color="#ec6608"
              positive-color="#01713c"
              unit="€"
            />
          </v-col>
          <v-col
            v-if="!$vuetify.breakpoint.mobile && hasTresoreriePositive && hasTresorerieNegative"
            cols="1"
          >
            <v-divider vertical />
          </v-col>
          <v-col
            v-if="hasTresorerieNegative"
            cols="12"
            md="5"
          >
            <div
              class="d-flex my-4 libelle-treso"
              :class="estMobile ? 'flex-wrap' : ''"
            >
              <img
                alt="picto-cochon"
                class="picto-cochon align-self-center mr-3"
                src="@/assets/picto-petit-cochon-moins.svg"
              >
              <div class="titre-h4 texte-gris-fonce align-self-center ">
                Trésorerie négative :
              </div>
              <div
                class="titre-h3 text-orange align-self-center montant-treso"
                :class="estMobile ? 'w-100' : 'ml-2'"
              >
                -{{ tresorerieNegativeTotaleEnEuro | roundNumber(0) | splitNumber }} €
              </div>
            </div>
            <RepartitionBarVertical
              v-model="valueCode"
              :class="estMobile ? '' : 'ml-3'"
              :data="{ items: itemsTresorerieNegative, positive: false }"
              :height="hauteurGraphe(tresorerieNegativeTotaleEnEuro)"
              negative-color="#ec6608"
              positive-color="#01713c"
              unit="€"
            />
          </v-col>
        </v-row>
        
        <div class="bottom">
          <v-divider class="my-6 mx-3" />
          <div class="d-flex justify-space-between mx-3">
            <div class="d-flex flex-column">
              <div class="titre-h4 texte-gris-fonce mb-2">
                Total trésorerie disponible
              </div>
              <div class="d-flex">
                <span
                  class="titre-h3 align-self-center mr-2"
                  :class="estTresorerieTotalePositive ? 'secondary--text' : 'text-orange'"
                >{{ estTresorerieTotalePositive ? '+' : '-' }}{{ tresorerieTotaleAbsolueEnEuro | roundNumber(0) | splitNumber }} € </span>
                <BaseEvolutionWithInfo
                  v-if="evolutionTresorerieEnPourcentage != null"
                  :evolution-value="evolutionTresorerieEnPourcentage"
                  :values="tresorerieParAnnee"
                  unite="%"
                />
              </div>
            </div>
            <div>
              <UserIndicatorJauge
                :chargement="loading.repartitionGroupe"
                :data="{
                  value: positionJaugeGroupe(repartitionTresorerieGroupe?.codePositionDuNumtiers)
                }"
                :data-groupe="repartitionTresorerieGroupe?.valeurMoyenneDuGroupe"
                unite="€"
                :is-parametres-exploitation-incomplet="!isParametresExploitationComplet"
                :negative-color="repartitionTresorerieGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#ec6608' : 'grey'"
                :positive-color="repartitionTresorerieGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#01713c' : 'grey'"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        key="tresorerie-empty-content"
      >
        <div
          class="d-flex
        align-center
        flex-column"
          :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-16' "
        >
          <img
            src="@/assets/no-tresorerie.svg"
            alt="no-tresorerie"
          >
          <div
            class="intro texte-gris-fonce text-align-center mt-2"
            :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          >
            <span>Découvrez la trésorerie disponible sur l’année culturale ainsi que le détail par culture de vente</span>
          </div>
        </div>
      </div>
      <HelpModal
        v-if="isOpenModalHelp"
        titre="Répartition de la trésorerie disponible"
        :is-open-modal-help="isOpenModalHelp"
        @close="isOpenModalHelp = false"
      >
        <div slot="baseCardHelpContent">
          <div class="texte text-justify texte-gris-fonce pa-8">
            <p>La trésorerie dégagée par culture est calculée ainsi : (Prix de vente (€/ha) - Prix d'équilibre (€/ha)) x surface de la culture = trésorerie disponible par culture.</p>
            <p>Calculée en fonction du prix de vente, elle pourra être amenée à évoluer tout au long de la campagne de commercialisation.</p>
            <p>La trésorerie dégagée par culture est à relativiser avec l'intérêt agronomique de la culture dans la rotation.</p>
          </div>
        </div>
      </HelpModal>

      <InformationAbonnementModal
        v-if="isOpenModalAideInformationAbonnement"
        :is-open-modal-information-abonnement="isOpenModalAideInformationAbonnement"
        code-feature="BILAN_ANNUEL"
        texte="Soyez accompagné par un expert pour faire le bilan de vos coûts et résultats de vos grandes cultures."
        titre="Bilan annuel de vos cultures"
        :is-conseiller-pv-affiche="!isAbonneCulturial"
        @close="isOpenModalAideInformationAbonnement = false"
      />
    </div>
  </BaseCardV2>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { reperesParCode } from '@/utils/palette-repartition'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseEvolutionWithInfo from '@/components/common/base-evolution-with-info.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import RepartitionBarVertical from '@/components/chart/v2/repartition-bar-vertical.vue'
import UserIndicatorJauge from '@/components/chart/v2/user-indicator-jauge.vue'
import { isPanneServeur } from '@/utils/requete'

const HAUTEUR_GRAPHE_MAX = 212
const HAUTEUR_HABILLAGE = 55

export default {
  name: 'RepartitionTresorerieDisponible',
  components: {BaseCardV2, BaseEvolutionWithInfo, BaseLoader, HelpModal, InformationAbonnementModal, RepartitionBarVertical, UserIndicatorJauge },
  props: {
    codeGraineRs3Selected: {
      type: String,
      default: null
    },
    anneeRecolteSelected: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isOpenModalHelp: false,
      loading: {
        repartitionAdherent: false,
        repartitionGroupe: false
      },
      erreur: {
        repartitionAdherent: false
      },
      isOpenModalAideInformationAbonnement: false
    }
  },

  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      atelierCultureVerrouillage: 'cloture/atelierCultureVerrouillage',
      repartitionTresorerie: 'cloture/repartitionTresorerie',
      evolutionTresorerie: 'cloture/evolutionTresorerie',
      repartitionTresorerieGroupe: 'cloture/repartitionTresorerieGroupe',
      repartitionGrandesCultures: 'culture/repartitionGrandesCultures',
      codeCultureMiseEnValeur: 'app/codeCultureMiseEnValeur',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet'
    }),
    reperesDesGrandesCultures () {
      const cultures = this.repartitionGrandesCultures?.cultures

      return reperesParCode(cultures?.map(culture => culture.codeTypeCulture))
    },
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
    hasClotureVerrouillee () {
      return this.atelierCultureVerrouillage != null && this.atelierCultureVerrouillage.isAtelierVerrouille
    },
    itemsTresoreriePositive () {
      return this.versItemsRepartition(this.repartitionTresorerie?.tresoreriePositive)
    },
    itemsTresorerieNegative () {
      return this.versItemsRepartition(this.repartitionTresorerie?.tresorerieNegative)
    },
    hasTresoreriePositive () {
      return this.itemsTresoreriePositive.length > 0
    },
    valueCode: {
      get () {
        return this.codeCultureMiseEnValeur
      },
      set (codeTypeCulture) {
        this.mettreEnValeurCulture(codeTypeCulture)
      }
    },
    hasTresorerieNegative () {
      return this.itemsTresorerieNegative.length > 0
    },
    estMobile () {
      return this.$vuetify.breakpoint.mobile
    },
    hasGraphAffiche () {
      return this.hasTresoreriePositive || this.hasTresorerieNegative
    },
    tresoreriePositiveTotaleEnEuro () {
      return this.repartitionTresorerie?.tresoreriePositiveTotaleEnEuro
    },
    tresorerieNegativeTotaleEnEuro () {
      const total = this.repartitionTresorerie?.tresorerieNegativeTotaleEnEuro

      return total != null ? Math.abs(total) : null
    },
    tresorerieTotaleEnEuro () {
      return this.repartitionTresorerie?.tresorerieTotaleEnEuro
    },
    estTresorerieTotalePositive () {
      return this.tresorerieTotaleEnEuro == null || this.tresorerieTotaleEnEuro >= 0
    },
    tresorerieTotaleAbsolueEnEuro () {
      return this.tresorerieTotaleEnEuro != null ? Math.abs(this.tresorerieTotaleEnEuro) : null
    },
    evolutionTresorerieEnPourcentage () {
      return this.evolutionTresorerie?.evolutionTresorerieEnPourcentage
    },
    tresorerieParAnnee () {
      return this.evolutionTresorerie?.tresorerieParAnnee
    },
    hasCarteRemplie () {
      return this.isAbonneCulturial
        && this.hasClotureVerrouillee
        && this.repartitionTresorerie != null
    }
  },
  watch: {
    anneeRecolteSelected: {
      immediate: true,
      handler () {
        this.reloadComponent()
        this.loadRepartitionAdherent()
      }
    },

    codeGraineRs3Selected () {
      this.reloadComponent()
    },

    hasClotureVerrouillee () {
      this.loadRepartitionAdherent()
    },

    isAbonneCulturial () {
      this.loadRepartitionAdherent()
    },

    filtresAdherent () {
      this.loadRepartitionGroupe()
    }
  },
  methods: {
    ...mapActions({
      incrementerAccesSouscriptionAbonnement : 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement',
      mettreEnValeurCulture: 'app/mettreEnValeurCulture',
      getRepartitionTresorerie: 'cloture/getRepartitionTresorerie',
      getEvolutionTresorerie: 'cloture/getEvolutionTresorerie',
      getRepartitionTresorerieGroupe: 'cloture/getRepartitionTresorerieGroupe'
    }),
    hauteurGraphe (montantEnEuro) {
      const reference = Math.max(
        Math.abs(this.tresoreriePositiveTotaleEnEuro || 0),
        Math.abs(this.tresorerieNegativeTotaleEnEuro || 0)
      )

      if (reference === 0) {
        return HAUTEUR_GRAPHE_MAX
      }

      const part = Math.abs(montantEnEuro || 0) / reference

      return Math.round(HAUTEUR_HABILLAGE + (HAUTEUR_GRAPHE_MAX - HAUTEUR_HABILLAGE) * part)
    },
    reloadComponent () {
      this.valueCode = null
    },
    versItemsRepartition (tresoreriesParCulture) {
      if (tresoreriesParCulture == null) {
        return []
      }

      const reperes = this.reperesDesGrandesCultures
      const rangDe = tresorerieCulture => reperes[tresorerieCulture.typeCulture.code]?.rang ?? Number.MAX_SAFE_INTEGER

      return [...tresoreriesParCulture]
        .sort((premier, second) => rangDe(premier) - rangDe(second))
        .map(tresorerieCulture => ({
          code: tresorerieCulture.typeCulture.code,
          label: tresorerieCulture.typeCulture.nom,
          value: Math.round(tresorerieCulture.tresorerieEnEuro),
          percentage: tresorerieCulture.partTresorerieEnPourcentage,
          color: reperes[tresorerieCulture.typeCulture.code]?.couleur
        }))
        .filter(item => item.value !== 0)
    },
    loadRepartitionAdherent () {
      if (!this.isAbonneCulturial || !this.hasClotureVerrouillee) {
        this.loading.repartitionAdherent = false
        this.erreur.repartitionAdherent = false
        return
      }

      this.loading.repartitionAdherent = true
      this.erreur.repartitionAdherent = false
      this.getRepartitionTresorerie()
        .then(() => {
          this.getEvolutionTresorerie().catch(() => {})
          this.loadRepartitionGroupe()
        })
        .catch((erreur) => {
          this.erreur.repartitionAdherent = isPanneServeur(erreur)
        })
        .finally(() => {
          this.loading.repartitionAdherent = false
        })
    },
    loadRepartitionGroupe () {
      if (!this.hasCarteRemplie) {
        return
      }

      this.loading.repartitionGroupe = true
      this.getRepartitionTresorerieGroupe()
        .catch(() => {})
        .finally(() => {
          this.loading.repartitionGroupe = false
        })
    },
    positionJaugeGroupe (codePosition) {
      let result = null
      switch (codePosition) {
        case 'QUARTILE_SUP':
          result = 'positive'
          break
        case 'QUARTILE_INF':
          result = 'negative'
          break
        case 'MOYENNE':
          result = 'center'
          break
      }

      return result
    },
    onClickInformationAbonnement () {
      this.isOpenModalAideInformationAbonnement = true
      this.incrementerAccesSouscriptionAbonnement('BILAN_ANNUEL')
    }
  }
}

</script>

<style lang="scss" scoped>
.picto-ferme {
  width: 32%;
}
.positif-color {
  color: #dbbd00;
}
.negatif-color {
  color: #ec6608;
}
.picto-cochon {
  width: 6%;
}
.text-orange {
  color: var(--orange-dark);
}

.libelle-treso {
  margin-left: 12px;
}

@media (min-width: 960px) {
  .libelle-treso {
    margin-left: calc(-10% + 12px);
  }
}

@media (max-width: 960px) {
  .picto-cochon {
    width: 28px;
  }
  .montant-treso {
    margin-left: 40px;
  }
}
</style>
